/**
 * Created by filatov on 17.09.2015.
 */
import CSVPreviewSection from '../CSVPreviewSection'
import PreviewSection from '../../PreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function CostCSVPreviewHeaderSection() {}

CostCSVPreviewHeaderSection.prototype = new CSVPreviewSection();

CostCSVPreviewHeaderSection.prototype.init = function( columnsStrategy, firstGroupingLevel, secondGroupingLevel,thirdGroupingLevel, numOfGroupingLevels )
{
    PreviewSection.prototype.init.call( this );
    this.columnsStrategy = columnsStrategy;
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.numOfGroupingLevels = numOfGroupingLevels;

    return this;
};

CostCSVPreviewHeaderSection.prototype.addRows = function( tBody )
{
    var countLevels = this.columnsStrategy.getCountGroupingRows();
    if(countLevels >= 3)
    {
        var thirdRow = this.createRow( "headerGroupingRow" );
        ReportPreviewUtils.addEmptyCells(thirdRow, this.numOfGroupingLevels);
        this.columnsStrategy.addThirdHeaderRowDataCells( thirdRow );
        this.addRow( tBody, thirdRow );
    }
    if(countLevels >= 2){
        var secondRow = this.createRow( "headerGroupingRow secondHeaderRow" );
        ReportPreviewUtils.addEmptyCells(secondRow, this.numOfGroupingLevels);
        this.columnsStrategy.addSecondHeaderRowDataCells( secondRow );
        this.addRow( tBody, secondRow );
    }
    if(countLevels >= 1){
        var firstRow = this.createRow( "headerGroupingRow firstHeaderRow" );
        this.addCell( firstRow, ReportPreviewUtils.getLevelPreviewName( this.firstGroupingLevel ) );
        if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
            this.addCell( firstRow, ReportPreviewUtils.getLevelPreviewName( this.secondGroupingLevel ) );
        if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
            this.addCell( firstRow, ReportPreviewUtils.getLevelPreviewName( this.thirdGroupingLevel ) );
        this.columnsStrategy.addFirstHeaderRowDataCells( firstRow );
        this.addRow( tBody, firstRow );
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewHeaderSection.js